/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step3_Embed_On_Sync_Seaweed_DescriptionInputs */



/**
* | output |
* | --- |
* | "Embedding automation is only available for cloud providers (Google Drive, OneDrive, GitHub). Local storage spaces don't require automatic embedding." |
*
* @param {Spaces_Wizard_Step3_Embed_On_Sync_Seaweed_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step3_embed_on_sync_seaweed_description = /** @type {((inputs?: Spaces_Wizard_Step3_Embed_On_Sync_Seaweed_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step3_Embed_On_Sync_Seaweed_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Embedding-Automatisierung ist nur für Cloud-Speicheranbieter verfügbar (Google Drive, OneDrive, GitHub). Lokale Speicher-Spaces benötigen kein automatisches Embedding.")
	return /** @type {LocalizedString} */ ("Embedding automation is only available for cloud providers (Google Drive, OneDrive, GitHub). Local storage spaces don't require automatic embedding.")
});